import BodyView from "@/layout/BodyView.vue";
import Bank from "@/pages/master/bank/Index.vue";
import Customer from "@/pages/master/customer/Index.vue";
import Destination from "@/pages/master/destination/Index.vue";
import Divisi from "@/pages/master/divisi/Index.vue";
import Engagement from "@/pages/master/engagement/Index.vue";
import Item from "@/pages/master/item/Index.vue";
import PurchaseDestination from "@/pages/master/purchase-destination/Index.vue";
import shipping from "@/pages/master/shipping/Index.vue";
import Vendor from "@/pages/master/vendor/Index.vue";
import Warehouse from "@/pages/master/warehouse/Index.vue";
import ResponsePatient from "@/pages/master/response_patient/Index.vue";
import Platform from "@/pages/master/platform/Index.vue";
import Terapist from "@/pages/master/terapist/Index.vue";
import Medicine from "@/pages/master/medicine/Index.vue";
import Interaction from "@/pages/master/interaction/Index.vue";


export const route = 
{
  path: "/master",
  component: BodyView,
  children: [
    {
      path: "bank",
      name: "bank",
      component: Bank,
      meta: {
        title: 'Bank | INDOFORCETECH',
      }
    },
    {
      path: "customer",
      name: "customer",
      component: Customer,
      meta: {
        title: 'Customer | INDOFORCETECH',
      }
    },
    {
      path: "destination",
      name: "destination",
      component: Destination,
      meta: {
        title: 'Destination | INDOFORCETECH',
      }
    },
    {
      path: "divisi",
      name: "divisi",
      component: Divisi,
      meta: {
        title: 'Divisi | INDOFORCETECH',
      }
    },
    {
      path: "engagement",
      name: "engagement",
      component: Engagement,
      meta: {
        title: 'Engagement | INDOFORCETECH',
      }
    },
    {
      path: "interaction",
      name: "interaction",
      component: Interaction,
      meta: {
        title: 'Interaction | INDOFORCETECH',
      }
    },
    {
      path: "item",
      name: "item",
      component: Item,
      meta: {
        title: 'Item | INDOFORCETECH',
      }
    },
    {
      path: "purchase-destination",
      name: "purchase-destination",
      component: PurchaseDestination,
      meta: {
        title: 'Purchase Destination | INDOFORCETECH',
      }
    },
    {
      path: "shipping",
      name: "shipping",
      component: shipping,
      meta: {
        title: 'Shipping | INDOFORCETECH',
      }
    },
    {
      path: "vendor",
      name: "vendor",
      component: Vendor,
      meta: {
        title: 'Vendor | INDOFORCETECH',
      }
    },
    {
      path: "warehouse",
      name: "warehouse",
      component: Warehouse,
      meta: {
        title: 'Warehouse | INDOFORCETECH',
      }
    },
    {
      path: "response-patient",
      name: "response-patient",
      component: ResponsePatient,
      meta: {
        title: 'ResponsePatient | INDOFORCETECH',
      }
    },
    {
      path: "platform",
      name: "platform",
      component: Platform,
      meta: {
        title: 'Platform | INDOFORCETECH',
      }
    },
    {
      path: "terapist",
      name: "terapist",
      component: Terapist,
      meta: {
        title: 'Terapist | INDOFORCETECH',
      }
    },
    {
      path: "medicine",
      name: "medicine",
      component: Medicine,
      meta: {
        title: 'Medicine | INDOFORCETECH',
      }
    },
  ]
}